import { render, staticRenderFns } from "./SafetySocialTips.vue?vue&type=template&id=cb5f10c2&scoped=true&"
import script from "./SafetySocialTips.vue?vue&type=script&lang=js&"
export * from "./SafetySocialTips.vue?vue&type=script&lang=js&"
import style0 from "./SafetySocialTips.vue?vue&type=style&index=0&id=cb5f10c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5f10c2",
  null
  
)

export default component.exports